module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sara Douglass\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Sara Douglass was born in Adelaide but moved to Hobart in later life to write full-time. Three of her books won the Aurealis Award for Best Fantasy and many were shortlisted. She published nineteen books of epic and historical fantasy before her death in 2011.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/stSffN/tc-custom/9780061997020.jpg?1737195675053",
      "alt": "This image is the cover for the book Infinity Gate, DarkGlass Mountain Series"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Infinity Gate, DarkGlass Mountain Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“Sara Douglass has the breadth of vision necessary to create sweeping epics and the storyteller’s gift that makes readers love her.” ")]), _c('p'), _c('p', [_vm._v("—"), _c('i', [_vm._v("Locus")])]), _c('p'), _c('p'), _vm._v("Sara Douglas fans have been eagerly awaiting the third book of her epic DarkGlass Mountain fantasy trilogy…and now the dramatic conclusion is here! "), _c('i', [_vm._v("The Infinity Gate")]), _vm._v("—a magnificent tale of love, magic, and betrayal set in the world of her bestselling Wayfarer Redemption—has the sweep, passion, and excitement of the best world-building efforts of Jacqueline Carey, Raymond E. Feist, Robin Hobb, and Lois McMaster Bujold, as it brings Douglas’s breathtaking fantasy saga to a powerful and extraordinarily satisfying end.\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0